import { useState } from "react";
import { useApi, Status } from "./useApi";

export const AtletasView = ({ onAtleta, globalDep = "" }) => {
  const [q, setQ] = useState("");
  const [deporte, setDeporte] = useState("");
  const [filtro, setFiltro] = useState("");
  const { data: f } = useApi("/filtros");
  const { data, error } = useApi("/atletas", { q, deporte: deporte || globalDep, filtro });
  return (
    <div data-testid="atletas-view">
      <div className="fgrid">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar atleta…" aria-label="Buscar atleta" data-testid="atletas-search-input" />
        <select value={deporte} onChange={(e) => setDeporte(e.target.value)} aria-label="Deporte" data-testid="atletas-deporte-select">
          <option value="">Todos los deportes</option>
          {(f?.deportes || []).map((d) => <option key={d}>{d}</option>)}
        </select>
        <select value={filtro} onChange={(e) => setFiltro(e.target.value)} aria-label="Filtro" data-testid="atletas-filtro-select">
          <option value="">Todos</option><option value="p">Solo prioridad</option><option value="m">Solo menores</option>
        </select>
      </div>
      <Status data={data} error={error} />
      {data && (
        <>
          <p className="note" data-testid="atletas-count">{data.length} atletas</p>
          <div className="wrapx">
            <table className="tbl" data-testid="atletas-table">
              <thead><tr><th>Nombre</th><th>Edad</th><th>Equipo</th><th>Global</th><th></th></tr></thead>
              <tbody>
                {data.map((a) => (
                  <tr key={a.id} className="clk" onClick={() => onAtleta(a.id)} data-testid={`atleta-row-${a.id}`}>
                    <td>{a.nombre}</td><td>{a.edad || ""}</td><td>{a.equipo}</td><td>{a.GLOBAL ?? ""}</td>
                    <td>{a.prioridad && <span className="badge r">prioridad</span>} {a.menorDeEdad && <span className="badge">menor</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};
